import React from 'react';
import { Link } from 'react-router-dom';
import '../css/FeaturesPage.css';

const FeaturesPage = () => {
  const topFeatures = [
    {
      icon: '🔗',
      title: 'Easy Link Shortening',
      text: 'Shorten long URLs with one click and share instantly.',
    },
    {
      icon: '✍️',
      title: 'Custom Aliases',
      text: 'Pick memorable aliases like /summer-sale or /portfolio.',
    },
    {
      icon: '📊',
      title: 'Detailed Analytics',
      text: 'Track clicks, unique visitors, devices, and referrers.',
    },
    {
      icon: '🛡️',
      title: 'Secure & Reliable',
      text: 'Fast redirects with stable uptime and safe handling.',
    },
  ];

  const reasons = [
    {
      icon: '🚀',
      title: 'Fast & Easy',
      text: 'Create short links in seconds from desktop or mobile.',
    },
    {
      icon: '📈',
      title: 'Link Tracking',
      text: 'Understand performance with real metrics over time.',
    },
    {
      icon: '🧾',
      title: 'QR Code Generation',
      text: 'Get a scannable QR code for every newly shortened URL.',
    },
  ];

  return (
    <div className="features-page">
      <section className="features-hero">
        <div className="features-hero-inner">
          <h1>The Best URL Shortener</h1>
          <p>Shorten, Share &amp; Track Your Links</p>

          <div className="features-hero-form" aria-hidden="true">
            <input type="text" value="Paste your long URL here..." readOnly />
            <button type="button">Shorten URL</button>
          </div>

          <div className="features-grid top-grid">
            {topFeatures.map((item) => (
              <article className="feature-card" key={item.title}>
                <span className="feature-icon">{item.icon}</span>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="features-why">
        <h2>Why Choose BlinkURL?</h2>
        <div className="features-grid why-grid">
          {reasons.map((item) => (
            <article className="feature-card" key={item.title}>
              <span className="feature-icon">{item.icon}</span>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
          <article className="feature-illustration">
            <div className="analytics-preview">
              <div className="bar" />
              <div className="bar" />
              <div className="bar" />
              <div className="line" />
            </div>
            <p>Live analytics and growth-ready sharing tools.</p>
          </article>
        </div>
        <Link to="/signup" className="features-cta">Get Started Now</Link>
      </section>
    </div>
  );
};

export default FeaturesPage;
